function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M30.964 15C30.472 7.512 24.488 1.526 17 1.034V1h-2v.034C7.512 1.526 1.526 7.512 1.034 15H1v2h.034C1.526 24.488 7.512 30.472 15 30.964V31h2v-.036c7.488-.492 13.472-6.476 13.964-13.964H31v-2h-.036zM10.39 4.27C9.424 5.554 8.622 7.164 8.038 9H5.042a13.068 13.068 0 0 1 5.348-4.73zM3.996 11h3.516a23.752 23.752 0 0 0-.492 4H3.038c.106-1.408.438-2.754.958-4zm-.958 6H7.02c.054 1.394.224 2.736.492 4H3.996a12.887 12.887 0 0 1-.958-4zm2.004 6h2.994c.584 1.836 1.386 3.446 2.354 4.73A13.054 13.054 0 0 1 5.042 23zM15 28.872c-2.056-.55-3.826-2.758-4.9-5.872H15v5.872zM15 21H9.538a22.353 22.353 0 0 1-.518-4H15v4zm0-6H9.02c.058-1.408.236-2.754.518-4H15v4zm0-6h-4.9c1.074-3.114 2.844-5.322 4.9-5.87V9zm11.958 0h-2.992c-.586-1.836-1.386-3.446-2.356-4.73A13.081 13.081 0 0 1 26.958 9zM17 3.13c2.054.548 3.826 2.756 4.9 5.87H17V3.13zM17 11h5.46c.284 1.246.458 2.592.52 4H17v-4zm0 6h5.98a22.17 22.17 0 0 1-.52 4H17v-4zm0 11.872V23h4.9c-1.074 3.114-2.846 5.322-4.9 5.872zm4.61-1.142c.966-1.286 1.77-2.894 2.356-4.73h2.992a13.067 13.067 0 0 1-5.348 4.73zM28.004 21h-3.516c.268-1.264.438-2.606.492-4h3.98a12.83 12.83 0 0 1-.956 4zm-3.024-6a23.752 23.752 0 0 0-.492-4h3.516c.52 1.246.852 2.592.958 4H24.98z"
});

var SvgWeb = function SvgWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "9e2f5da2eb2d12cd0df50474574e3444.svg";
export { SvgWeb as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/web.svg
// module id = null
// module chunks = 